import { Cell } from 'fixed-data-table-2';
import PropTypes from 'prop-types';
import React from 'react';

const classNames = require('classnames');

export default class SortableHeaderCell extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      sortDir: this.props.sortTable?.sortDir || 'asc',
    };
    this.onSortChange = this.onSortChange.bind(this);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    // Sync state with props when sortTable changes
    if (nextProps.sortTable) {
      const isActive = nextProps.sortTable.sortBy === this.props.columnKey;
      const wasActive = this.props.sortTable?.sortBy === this.props.columnKey;

      if (isActive && nextProps.sortTable.sortDir) {
        // This column is active, sync with props
        if (nextProps.sortTable.sortDir !== this.state.sortDir) {
          this.setState({ sortDir: nextProps.sortTable.sortDir });
        }
      } else if (wasActive && !isActive) {
        // This column was active but is no longer, reset to default
        this.setState({ sortDir: 'asc' });
      }
    }
  }

  onSortChange(e) {
    // Determine the new sort direction
    const isCurrentlyActive =
      this.props.sortTable.sortBy === this.props.columnKey;
    let sortDir;

    if (isCurrentlyActive) {
      // If this column is already active, toggle the direction
      const currentDir = this.props.sortTable.sortDir || this.state.sortDir;
      sortDir = currentDir === 'desc' ? 'asc' : 'desc';
    } else {
      // If this column is not active, start with ascending
      sortDir = 'asc';
    }

    // Update local state immediately for visual feedback
    this.setState({ sortDir });
    // Call the sort action
    this.props.sortTable.sort(this.props.columnKey, sortDir);
  }
  render() {
    const { columnKey, sortTable, title } = this.props;
    const { sortDir } = this.state;
    const active = sortTable.sortBy === columnKey;

    // Determine the active sort direction:
    // - If this column is active and sortTable has sortDir, use that (from Redux)
    // - If this column is active but sortTable.sortDir is not set yet, use local state (immediate feedback)
    // - If this column is not active, use local state
    const activeSortDir = active ? sortTable.sortDir || sortDir : sortDir;
    const titles = {
      Priority: this.context.t('blank_space'),
      AvgGrowthAngle: 'LG',
      ID: this.context.t('id'),
      id: this.context.t('id'),
      DetectedAt: this.context.t('detected'),
      AlertType: this.context.t('type'),
      AlertTypeMeaning: this.context.t('type'),
      AlertState: this.context.t('status'),
      alert_state: this.context.t('status'),
      AlertStateMeaning: this.context.t('status'),
      SensorStatus: this.context.t('status'),
      comment: this.context.t('comment'),
      DaysInactive: this.context.t('last_run_days'),
      DeviceID: this.context.t('device_id'),
      SensorID: this.context.t('sensor_id'),
      Address: this.context.t('address'),
      StreetAddress: this.context.t('address'),
      City: this.context.t('city'),
      ProbabilityLeak: this.context.t('Probability'),
      Intensity: this.context.t('intensity'),
      Probability: this.context.t('Probability'),
      probability_irrigation: this.context.t('Probability_AQS'),
      Distance: this.context.t('distance'),
      ranking: this.context.t('ranking'),
      // Sensors
      warning: this.context.t('w'),
      DeviceInstallationDate: this.context.t('install_date'),
      MaintenanceDate: this.context.t('maintenance_date'),
      Nc2: this.context.t('noise'),
      Nc1: this.context.t('min'),
      // 'Nc2': this.context.t('2'),
      Nc3: this.context.t('nc_3'),
      Nc3f1: this.context.t('low'),
      Nc3f2: this.context.t('med'),
      Nc3f3: this.context.t('hi'),

      // Samples
      sampleTime: this.context.t('sample_time'),
      weightedDistance: this.context.t('weighted_distance'),
      instanceIntensity: this.context.t('intensity'),
      weightedIntensity: this.context.t('weighted_intensity'),
      instanceDistance: this.context.t('distance'),
      LeakID: this.context.t('leak_id'),
      // Couples
      warningEnum: this.context.t('blank_space'),
      PathLengthM: this.context.t('pipe_length'),
      Material: this.context.t('material'),
      Sensor1: this.context.t('sensor_1'),
      Sensor2: this.context.t('sensor_2'),
      LastDaemonActivity: this.context.t('updated'),

      // Couples Samples
      SampleDateAndTime: this.context.t('sample_time'),
      IntensityA: this.context.t('weighted_intensity'),
      IntensityI: this.context.t('sample_intensity'),
      DistanceAM: this.context.t('weighted_distance'),
      DistanceIM: this.context.t('sample_distance'),

      // Users
      UserName: this.context.t('user_name'),
      Email: this.context.t('email'),
      FirstName: this.context.t('first_name'),
      LastName: this.context.t('last_name'),
      CustomerName: this.context.t('customer_name'),

      // SOPs
      Type: this.context.t('type'),
      State: this.context.t('state'),
      AssetID: this.context.t('asset_id'),
      Model: this.context.t('model'),

      // Projects
      SensorActivityRatioDaysBack: this.context.t('threshold'),
      PilotModeLabel: this.context.t('mode'),
      ShortName: this.context.t('project_name'),

      // Customers
      Name: this.context.t('name'),
      CustomerName: this.context.t('customer_name'),
      ContactPerson: this.context.t('contact_name'),

      // iQuarius
      TaskName: this.context.t('task_name'),
      CreationTime: this.context.t('creation_time'),
      CreationDate: this.context.t('creation_date'),
      SamplesCount: this.context.t('samples_count'),
      TaskID: this.context.t('task_id'),
      SampleTime: this.context.t('sample_time'),
      Status: this.context.t('status'),
      Quality: this.context.t('quality'),
      Comments: this.context.t('comments'),
      DistanceOfLeakFromDevice1: this.context.t('dist_m'),

      // Mobile Alerts
      alert_id: this.context.t('alert_id'),
      CreationDate: this.context.t('creation_date'),
      Intensity: this.context.t('intensity'),
      Type: this.context.t('type'),
      TaskName: this.context.t('task_name'),
      Address: this.context.t('address'),
      Status: this.context.t('status'),
      Comment: this.context.t('comment'),

      // Interferences
      StartTime: this.context.t('start_time'),
      EndTime: this.context.t('end_time'),
      StartFrequency: this.context.t('start_frequency'),
      EndFrequency: this.context.t('end_frequncy'),

      // PCA
      DetectionDateTime: this.context.t('detected'),
      AlertTypeName: this.context.t('type'),
      AlertStateName: this.context.t('status'),

      // PrsTransientAlerts
      SessionNumEvents: this.context.t('n'),
      CreateDate: this.context.t('create_date'),
      EndDate: this.context.t('end_date'),
      LastEventTime: this.context.t('last_event_date'),
      LastEventMinValue: this.context.t('min_value'),
      LastEventMaxValue: this.context.t('max_value'),

      // NoiseAlerts
      InsertDate: this.context.t('alert_date'),
      EventDate: this.context.t('event_date'),
      AlertDate: this.context.t('alert_date'),
      Status: this.context.t('status'),
      SensorId: this.context.t('sensor_id'),
      Comment: this.context.t('comment'),

      // MobileSamples
      sample_time: this.context.t('sample_time'),
      device_id: this.context.t('device_id'),
      sample_state: this.context.t('status'),
      engine_intensity: this.context.t('intensity_db'),
      mobile_intensity: this.context.t('intensity_db'),
      mobile_quality: this.context.t('quality'),
      engine_quality: this.context.t('clarity'),
      user_comment: this.context.t('comment'),
      user_sop_classify: this.context.t('access_point'),
      user_sample_classify: this.context.t('classify'),
      Probability: this.context.t('Probability_AQS'),
      DmaComment: this.context.t('boundaries'),
      sample_images: this.context.t('sample_images'),

      timestamp: this.context.t('time'),
      user_name: this.context.t('user'),
      is_assambly: this.context.t('assambly'),

      // G5 tables
      LastStatusReportTime: this.context.t('last_updated'),
      BatteryLevel: this.context.t('battery_level'),
      BatteryLevelPost: this.context.t('battery_post'),
      AccessTechnologyName: this.context.t('tech'),
      IEMI: this.context.t('iemi'),
      ICCID: this.context.t('iccid'),
      StatusTimeZone: this.context.t('time_zone'),
      HwType: this.context.t('hw_t'),
      HardwareRevision: this.context.t('hw_v'),
      FirmwareRevision: this.context.t('fw_v'),
      RSRQ_db: this.context.t('rsrq'),
      RSRP_dbm: this.context.t('rsrp'),
      fm_channel_snr: this.context.t('snr1'),
      fm_channel2_snr: this.context.t('snr2'),
      agc_threshold1: this.context.t('thresh1'),
      agc_threshold2: this.context.t('thresh2'),
      agc_threshold3: this.context.t('thresh3'),
      agc_sensor_gain: this.context.t('agc_gain'),
      time_source: this.context.t('time_source'),
      is_valve_monitor: this.context.t('valve_leak'),
      is_burst_monitor: this.context.t('is_burst'),
      ad_hoc_corr: this.context.t('is_adhoc'),
      isMini: this.context.t('is_ultra'),
      pdp_type: this.context.t('pdp_type'),
      pco_type: this.context.t('pco_type'),
      APN: this.context.t('apn'),
      Server: this.context.t('server'),
      FallbackServer: this.context.t('secondary'),
      modem_fw_rev: this.context.t('modem_fw'),
      dfu_fw_rev: this.context.t('dfu_fw'),
      dfu_type: this.context.t('dfu_type'),
      dfu_block_num: this.context.t('dfu_block'),
      random_backoff_connect: this.context.t('random_backoff_connect'),
      psm_status: this.context.t('psm_status'),
      psm_interval_sec: this.context.t('psm_interval_sec'),

      SchedulerRefTime: this.context.t('sample_time'),
      ConfigTimeZone: this.context.t('time_zone'),
      SchedulerCorrInterval: this.context.t('corr_interval'),
      SchedulerCorrNumSamples: this.context.t('corr_num_samples'),
      SchedulerNoiseInterval: this.context.t('noise_interval'),
      SchedulerNoiseNumSamples: this.context.t('noise_num_samples'),
      SchedulerNoiseTxTime: this.context.t('noise_tx_time'),
      SchedulerWakeupBefor: this.context.t('wakeup_befor'),
      SchedulerRandomDelay: this.context.t('random_delay'),
      AudioRecordingDurationSec: this.context.t('noise_audio_duration'),
      CorrelationAudioRecordingDurationSec: this.context.t(
        'corr_audio_duration'
      ),
      CorrelationRadioRecordingDurationSec: this.context.t(
        'corr_radio_duration'
      ),
      AudioReportEnabled: this.context.t('audio_report_enabled'),
      CorrelationAudioSamplingFrequency: this.context.t('corr_sample_freq'),
      FmReceiverChannel_10k: this.context.t('fm1'),
      FmReceiverChannel2_10k: this.context.t('fm2'),
      fmReceiverChannel2_Config_name: this.context.t('fm2_conf'),
      LTEMode: this.context.t('lte_mode'),
      APN: this.context.t('apn'),
      Server: this.context.t('server'),
      FallbackServer: this.context.t('secondary'),
      catm_packet_size: this.context.t('catm_packet'),
      catm_rx_timeout: this.context.t('catm_rx_tout'),
      catm_tx_timeout: this.context.t('catm_tx_tout'),
      catm_flags: this.context.t('catm_flags'),
      nbiot_packet_size: this.context.t('nbiot_packet'),
      nbiot_rx_timeout: this.context.t('nbiot_rx_tout'),
      nbiot_tx_timeout: this.context.t('nbiot_tx_tout'),
      nbiot_flags: this.context.t('nbiot_flags'),
      psm_catm_str: this.context.t('psm_catm_str'),
      psm_nb_str: this.context.t('psm_nb_str'),
      fbr_threshold: this.context.t('fast_burst_threshold'),
      fbr_test_count: this.context.t('fast_burst_test_count'),
      fbr_idle_samples: this.context.t('fast_burst_idle_samples'),
      fbr_max_alerts: this.context.t('fast_burst_max_alerts'),
      second_keepalive: this.context.t('second_keepalive_enabled'),

      // valve alerts
      create_date: this.context.t('create_date'),
      sensor_id: this.context.t('sensor_id'),
      last_event_date: this.context.t('last_event_date'),
      last_event_rms: this.context.t('last_event_rms'),
      last_threshold_rms: this.context.t('last_threshold_rms'),
      test_count: this.context.t('test_count'),
      test_duration_min: this.context.t('test_duration_min'),
      alert_count: this.context.t('alert_count'),

      // Mobile devices
      customer_id: this.context.t('customer'),
      end_date: this.context.t('end_date'),
      usage_counter: this.context.t('usage_counter'),
      state: this.context.t('state'),

      // Pressure Sensors
      pressure_sensor_id: this.context.t('id'),
      logger_uid: this.context.t('logger_id'),
      aqs_logger_id: this.context.t('aqs_logger_id'),
      logger_type_name: this.context.t('type'),
      manufacture: this.context.t('manufacturer'),
      //sensor_installation_date: this.context.t('sensor_install_date'),
      logger_last_install_date: this.context.t('logger_install_date'),
      logger_last_active_time: this.context.t('last_active'),
    };

    if (this.props.tableName && this.props.tableName === 'AlertsTableNoise') {
      switch (this.props.tableName) {
        case 'AlertsTableNoise': {
          titles.CreateDate = this.context.t('event_date');
        }
      }
    }
    let columnKeyClass;
    switch (columnKey) {
      case 'Priority':
        columnKeyClass = 'priority';
        break;
      case 'Warning':
        columnKeyClass = 'warning';
        break;
      case 'IsLeak':
        columnKeyClass = 'drop';
        break;
      default:
        columnKeyClass = '';
        break;
    }
    const cellClasses = classNames(
      columnKey === 'Priority' ? 'priority' : columnKey,
      'sortable',
      'sort-' + activeSortDir,
      { 'sort-active': active },
      columnKeyClass
    );
    if (columnKey === 'SessionNumEvents') {
      return (
        <Cell
          onClick={this.onSortChange}
          className={cellClasses}
          title={this.context.t('number_of_transients')}
        >
          {titles[columnKey]}
        </Cell>
      );
    } else {
      return (
        <Cell
          onClick={this.onSortChange}
          className={cellClasses}
          title={title || titles[columnKey]}
        >
          {titles[columnKey] || title}
        </Cell>
      );
    }
  }
}

SortableHeaderCell.contextTypes = {
  t: PropTypes.func.isRequired,
};
